import React from 'react';

interface TagBadgeProps {
  titulo: string;
  cor?: string;
  prioridade?: string;
  className?: string;
  onClick?: () => void;
}

export const TagBadge: React.FC<TagBadgeProps> = ({
  titulo,
  cor = '#3B82F6',
  prioridade,
  className = '',
  onClick
}) => {
  return (
    <div
      className={`inline-flex items-center px-1.5 py-0.2 text-[10px] font-medium text-white ${className}`}
      style={{
        backgroundColor: cor,
        clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%)',
        paddingRight: '10px'
      }}
      title={titulo}
      onClick={onClick}
    >
      {prioridade && (
        <span className="w-2 h-2 rounded-full bg-white/60 mr-1.5" title={`Prioridade ${prioridade}`} />
      )}
      <span className="truncate max-w-[80px]">{titulo}</span>
    </div>
  );
};
